<template>
  <div>
    <div class="modal" tabindex="-1">
      <div class="wrapper">
        <header class="header">
          <div v-if="title" class="title">{{ title }}</div>
          <button class="close" type="button" :title="$t('close')" @click="close">x</button>
        </header>

        <div class="content">
          <slot />
        </div>
      </div>
    </div>

    <div class="backdrop" @click="close" />
  </div>
</template>

<script>
export default {
  name: "Modal",

  props: {
    title: String,
  },

  methods: {
    close() {
      this.$emit("close-modal")
    },
  },

  mounted() {
    document.body.classList.add("has-modal-active")
  },

  destroyed() {
    document.body.classList.remove("has-modal-active")
  },
}
</script>

<style lang="scss" scoped>
$_backdropIndex: 1000;

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.backdrop,
.modal {
  width: 100%;
  position: fixed;
  animation: fadeIn 250ms;
}

.backdrop {
  width: 100%;
  height: 100%;
  background: rgba(#000, 0.85);
  backdrop-filter: blur(0.65rem);
  z-index: $_backdropIndex;
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 0;
}

.modal {
  top: 0;
  left: 0;
  z-index: $_backdropIndex + 10;
  pointer-events: none;
  overflow: hidden;
  display: flex;

  .wrapper {
    height: 100vh;
    max-width: 1200px;
    width: 100%;
    margin: auto;
    padding: 1rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    @media (min-width: 700px) {
      padding: 2rem;
    }
  }

  .content {
    @include custom-scrollbar;

    overflow: auto;
    flex-grow: 1;
    pointer-events: all;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 1rem;
  }

  .title {
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.25rem;

    @media (min-width: 700px) {
      font-size: 3rem;
    }
  }

  .box {
    padding: 2rem;
    background: #fff;
    box-shadow: 0 0 2rem rgba(#000, 0.85);
  }

  .close {
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    border: 2px solid #fff;
    padding: 0.5rem 1rem;
    pointer-events: all;

    &:hover {
      color: #000;
      background: #fff;
    }
  }

  table {
    background: $light;
    box-shadow: 0 0 2rem rgba(#000, 0.85);
    min-width: 700px;
  }
}
</style>
